import React, { PureComponent } from 'react';
import { Cookies } from 'react-cookie';
import PropTypes from 'prop-types';
import SearchAlerts from '../..';
import './styles.css';

export default class SearchAlertsContainer extends PureComponent {
  render() {
    return (
      <div className="search-alerts-container">
        <SearchAlerts
          match={this.props.match}
          intl={this.props.intl}
          eventCategory={this.props.eventCategory}
        />
      </div>
    );
  }
}

SearchAlertsContainer.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.object,
  }),
  eventCategory: PropTypes.string,
  cookies: PropTypes.instanceOf(Cookies).isRequired,
};
